import React, { useState } from "react";
import { set } from "dot-prop-immutable";
import { toolFormAttr, toolCollapseAttr, selectCheckboxTreeDataSource, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Row, Col, Radio,Input } from '@whalecloud/fdx';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import StaticSettings from '../../tree/components/StaticSettings';
import RemoteSettings from '../../tree/components/RemoteSettings';

const { Panel } = Collapse;

const valueKey = 'data.formItemSettings';

const TreeSelectSettings = (props: any) => {
  const messages = getLocale();
  
  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const [dataMode, setDataMode] = useState('static')

  const handleChange = (e: any) => {
    setDataMode(e.target.value)
  }

  const {
    showSearch,
    autoInitialize,
    treeCheckable,
    treeDefaultExpandAll,
    treeNodeFilterProp
  } = formItemSettings;

  const initialValues = {
    autoInitialize,
    treeCheckable,
    showSearch,
    treeDefaultExpandAll,
    treeNodeFilterProp
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const newElement = set(element, propName, obj[key]);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonItemSettings />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_MULTIPLE']} name="treeCheckable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_SHOW_SEARCH']} name="showSearch" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_AUTO_INITILIZE']} name="autoInitialize" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_EXPANDALL']} name="treeDefaultExpandAll" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_ELEMENT_FILTER_ITEM']} name="treeNodeFilterProp">
            <Input />
          </Form.Item>
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_FORM_TABS_OPTIONS']} key="2">
        <Row gutter={8}>
          <Col span={24} align="center">
            <Radio.Group buttonStyle="solid" size="small" value={dataMode} onChange={handleChange}>
              <Radio.Button value="static">{messages['PAGEBUIDER_SETTINGS_DATASOURCE_STATIC']}</Radio.Button>
              <Radio.Button value="remote">{messages['PAGEBUIDER_SETTINGS_DATASOURCE_REMOTE']}</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        <Row className="my-4">
          <Col span={24}>
            {
              dataMode === 'static' && <StaticSettings treeData={selectCheckboxTreeDataSource} element={element} updateElement={updateElement} />
            }
            {
              dataMode === 'remote' && <RemoteSettings element={element} updateElement={updateElement} />
            }
          </Col>
        </Row>
      </Panel>
    </Collapse>
  );
};

export default TreeSelectSettings;
